module.exports = __webpack_public_path__ + "img/wrapbg9.d1a20f10.png";